import permissions from "app/permissions";
import PreviewIcon from "@mui/icons-material/Preview";
import ListSchedules from "./List";
import { StudentServicePath, WEEKLY_TABBED_SCHEDULE } from "utils/constants";

export const resources = {
  isMenu: true,
  icon: <PreviewIcon />,
  name: StudentServicePath + WEEKLY_TABBED_SCHEDULE,
  title: "Провери заетост",
  list: <ListSchedules />,
  permission: permissions.canPreviewWeeklySchedule,
};
